/**
 * Context exposing whether the visitor is signed in, from the layout AppContent
 * has already loaded. Components below it know the answer on their first render
 * instead of fetching the layout again and rendering a loading step first.
 * Null when no provider is above (the answer is unknown).
 */

import { createContext, useContext } from "react";

export const IsUserAuthenticatedContext = createContext<boolean | null>(null);

export function useIsUserAuthenticated(): boolean | null {
  return useContext(IsUserAuthenticatedContext);
}
